// Soap bubbles from a wand, in toy space with the floor at y=0. Dipping the
// wand's ring in the cup leaves a film on it. Moving the filmed wand through
// the air stretches the film into bubbles: a slow sweep makes a few big ones,
// a fast one many small ones, as with a real wand; each bubble uses up some
// film. Bubbles float almost weightless, drifting on a light breeze and
// wobbling; they pop at a touch, on the floor, or after a while.
export class SoapBubbles{
  constructor({size,cup,bounds,random=Math.random}){this.size=size;this.cup=cup;this.bounds=bounds;this.random=random;this.reset();}
  reset(){this.bubbles=[];this.wand={p:null,v:[0,0,0],film:0,travel:0};this.clock=0;}
  // blowing: false while the wand is only being put back.
  moveWand(p,dt,blowing=true){
    const events=[],w=this.wand,R=this.size,c=this.cup;
    // A jump (out of the cup to the finger) is a move, not a sweep.
    if(w.p&&dt>0)w.v=Math.hypot(...p.map((v,a)=>v-w.p[a]))>R*.6?[0,0,0]:p.map((v,a)=>(v-w.p[a])/dt);
    const speed=Math.hypot(...w.v);w.p=[...p];
    if(Math.hypot(p[0]-c.center[0],p[2]-c.center[2])<c.radius&&p[1]<c.top){if(w.film<1)events.push('dip');w.film=1;w.travel=0;return events;}
    if(!blowing||w.film<=0||speed<R*.25)return events;
    // A slower sweep lets the film balloon further before it closes off.
    const r=Math.max(R*.07,Math.min(R*.55,R*R*.45/Math.max(speed,1e-6)));
    w.travel+=speed*dt;
    while(w.travel>r*1.7&&w.film>0){
      w.travel-=r*1.7;w.film=Math.max(0,w.film-.06-.5*(r/R)**2);
      const rnd=this.random;
      // Air stops a new bubble fast: it keeps only a little of the sweep.
      const k=Math.min(.35,R*.7/Math.max(speed,1e-6));
      this.bubbles.push({p:[...p],v:w.v.map(v=>v*k+(rnd()-.5)*R*.2),r:r*(.85+.3*rnd()),age:0,life:7+6*rnd(),phase:rnd()*6,hue:rnd()});
      events.push('blow');
    }
    return events;
  }
  // Air pushed through the film at p (a squeezed bottle): one bubble floats up,
  // bigger and slower from a gentle squeeze, smaller and quicker from a hard one.
  puff(p,squeeze){
    const r=this.random,R=this.size,k=Math.max(0,Math.min(1,squeeze));
    this.bubbles.push({p:[...p],v:[(r()-.5)*R*.6,R*(.5+1.4*k),(r()-.5)*R*.3],r:R*(.3-.18*k)*(.75+.5*r()),age:0,life:7+6*r(),phase:r()*6,hue:r()});
    return ['blow'];
  }
  // Pop every bubble the touch is inside (a bubble just blown is still on its way).
  poke(point){
    const before=this.bubbles.length;
    this.bubbles=this.bubbles.filter(b=>b.age<.6||Math.hypot(...b.p.map((v,a)=>v-point[a]))>b.r*1.15);
    return before>this.bubbles.length?Array(before-this.bubbles.length).fill('pop'):[];
  }
  step(dt){
    const events=[],R=this.size,{min,max}=this.bounds;this.clock+=dt;
    const breeze=[Math.sin(this.clock*.4)*R*.12,0,Math.cos(this.clock*.3)*R*.05];
    this.bubbles=this.bubbles.filter(b=>{
      b.age+=dt;
      // Nearly as light as air: a slow sink, drag toward the breeze, a little wander.
      b.v[1]-=R*.12*dt;const drag=Math.exp(-1.2*dt);
      for(let a=0;a<3;a++){b.v[a]=breeze[a]+(b.v[a]-breeze[a])*drag+Math.sin(this.clock*1.7+b.phase+a*2)*R*.05*dt;b.p[a]+=b.v[a]*dt;}
      for(const a of [0,2]){if(b.p[a]<min[a]+b.r){b.p[a]=min[a]+b.r;b.v[a]=Math.abs(b.v[a]);}if(b.p[a]>max[a]-b.r){b.p[a]=max[a]-b.r;b.v[a]=-Math.abs(b.v[a]);}}
      if(b.p[1]>max[1]-b.r){b.p[1]=max[1]-b.r;b.v[1]=-Math.abs(b.v[1]);}
      if(b.p[1]<=b.r||b.age>b.life){events.push('pop');return false;}
      return true;
    });
    return events;
  }
}
